import { memo } from 'react';
import { AttachmentType } from '../../models/attachment';
import type { Message } from '../../models/message';
import { ReplyFilePreview } from './reply-file-preview';
import { ReplyLinkPreview } from './reply-link-preview';
import { ReplyMediaPreview } from './reply-media-preview';

interface ReplyComposePreviewProps {
  message: Message;
}

export const ReplyComposePreview = memo<ReplyComposePreviewProps>(({ message }) => {
  const mediaAttachments = message.structuredAttachments?.filter((f) => f.contentType === AttachmentType.MEDIA) || [];
  const fileAttachments = message.structuredAttachments?.filter((f) => f.contentType === AttachmentType.FILE) || [];
  const linkAttachment = message.structuredAttachments?.find((f) => f.contentType === AttachmentType.LINK);

  // Priority: Media > Link > File
  if (mediaAttachments.length > 0) {
    return <ReplyMediaPreview attachment={mediaAttachments[0] as any} />;
  }

  if (linkAttachment) {
    return <ReplyLinkPreview attachment={linkAttachment as any} />;
  }

  if (fileAttachments.length > 0) {
    return <ReplyFilePreview fileCount={fileAttachments.length} />;
  }

  // Fallback
  return <ReplyFilePreview fileCount={0} />;
});
